import { LocationGroup, LocationProfile } from 'src/app/core/models/admin';

interface Option {
  label: string;
  value: string | number;
}
export const IdoSpecificProperties = [
  'latitude',
  'longitude',
  'idoType',
  'optimizationEnabled',
  'startEndLocation',
  'locationEnd',
  'leaveBuildingTime',
  'vehicleType',
  'breakStart',
  'breakEnd',
  'breakDuration',
  'waitTimeDelivery',
  'waitTimePickup',
  'distanceUnits',
];
export const NonIdoConfigProperties = [
  'dataRetentionDays',
  'locationType',
  'messagingEnabled',
  'gioEnabled',
  'interceptsActive',
  'byodEnabled',
  'driverReleaseEnabled',
  'safePlacePhotoEnabled',
  'adlActive',
  'hazmatEnabled',
  'onRoadPickupEnabled',
  'onCallPickupProvideReceipt',
  'fileUploadEnabled',
  'centerSlicEnabled',
  'driverLoadVisibility',
  'handoverVisibility',
  'edwEtaApiOnlyVisibility',
  'supGroupDriver',
  'sendDataDriverTime',
  'supGroupLocation',
  'sendDataLocationTime',
  'contractorId',
  'contractorName',
  'additionalTimeCardFeed',
  'additionalContractorId',
  'additionalContractorName',
  'additionalSupGroup',
  'additionalSendDataTime',
  'edwEnabled',
  'followMyDeliveryEnabled',
  'itineraryReordering',
  'forecastSmartScanEnabled',
  'trimbleDispatchPlanning',
];
export interface GroupItem {
  index: number;
  id: unknown;
  selected: boolean;
  code: string;
  name: string;
}
export interface ProfileBundle {
  profile: LocationProfile;
  edit: boolean;
}
export const LOCATION_SETUP_OPTION: Option[] = [
  {
    label: `OSP In`,
    value: `OSP In`,
  },
  {
    label: `OSP Out`,
    value: `OSP Out`,
  },
  {
    label: `ASC`,
    value: `ASC`,
  },
  {
    label: `Brown`,
    value: `Brown`,
  },
  {
    label: '',
    value: '',
  },
];
export const LEAVE_BLDG_OPTIONS = [
  { label: '00:00', value: '00:00' },
  { label: '01:00', value: '01:00' },
  { label: '02:00', value: '02:00' },
  { label: '03:00', value: '03:00' },
  { label: '04:00', value: '04:00' },
  { label: '05:00', value: '05:00' },
  { label: '06:00', value: '06:00' },
  { label: '07:00', value: '07:00' },
  { label: '08:00', value: '08:00' },
  { label: '09:00', value: '09:00' },
  { label: '10:00', value: '10:00' },
  { label: '11:00', value: '11:00' },
  { label: '12:00', value: '12:00' },
  { label: '13:00', value: '13:00' },
  { label: '14:00', value: '14:00' },
  { label: '15:00', value: '15:00' },
  { label: '16:00', value: '16:00' },
  { label: '17:00', value: '17:00' },
  { label: '18:00', value: '18:00' },
  { label: '19:00', value: '19:00' },
  { label: '20:00', value: '20:00' },
  { label: '21:00', value: '21:00' },
  { label: '22:00', value: '22:00' },
  { label: '23:00', value: '23:00' },
];
export const HOUR_RANGES: Option[] = [
  { label: 'GMT-12:00', value: -12 },
  { label: 'GMT-11:00', value: -11 },
  { label: 'GMT-10:00', value: -10 },
  { label: 'GMT-09:00', value: -9 },
  { label: 'GMT-08:00', value: -8 },
  { label: 'GMT-07:00', value: -7 },
  { label: 'GMT-06:00', value: -6 },
  { label: 'GMT-05:00', value: -5 },
  { label: 'GMT-04:00', value: -4 },
  { label: 'GMT-03:00', value: -3 },
  { label: 'GMT-02:00', value: -2 },
  { label: 'GMT-01:00', value: -1 },
  { label: 'GMT+01:00', value: 1 },
  { label: 'GMT+02:00', value: 2 },
  { label: 'GMT+03:00', value: 3 },
  { label: 'GMT+04:00', value: 4 },
  { label: 'GMT+05:00', value: 5 },
  { label: 'GMT+06:00', value: 6 },
  { label: 'GMT+07:00', value: 7 },
  { label: 'GMT+08:00', value: 8 },
  { label: 'GMT+09:00', value: 9 },
  { label: 'GMT+10:00', value: 10 },
  { label: 'GMT+11:00', value: 11 },
  { label: 'GMT+12:00', value: 12 },
  { label: 'GMT+13:00', value: 13 },
];
export const MINUTE_RANGES: Option[] = [
  {
    label: '00',
    value: '00',
  },
  {
    label: '15',
    value: '15',
  },
  {
    label: '30',
    value: '30',
  },
  {
    label: '45',
    value: '45',
  },
];
export const TABS = {
  LOCATION: $localize`Location`,
  ADDRESS: $localize`Address`,
  GROUP: $localize`Group`,
  CONFIGURATION: $localize`Configuration`,
};
export const LOCATION_FORM_LABEL = {
  LOCATION_CODE: $localize`Location Code`,
  LOCATION_NAME: $localize`Location Name`,
  PKG_SLIC: $localize`PKG SLIC`,
  HUB_SLIC: $localize`HUB SLIC`,
  MNEMONIC: $localize`Mnemonic`,
  REGION: $localize`Region`,
  DISTRICT: $localize`District`,
  OSP_ID: $localize`OSP ID`,
  LOCATION_SETUP: $localize`Location Setup`,
  TIME_ZONE: $localize`Time Zone (GMT)`,
  HOURS: $localize`Time`,
  MINUTES: $localize`Minutes`,
  LOCALE_ID: $localize`Locale ID`,
  TIMEZONE: $localize`Time Zone`,
};
export const ADDRESS_FORM_LABEL = {
  COMPANY_NAME: $localize`Company Name`,
  ADDRESS_1: $localize`Address 1`,
  ADDRESS_2: $localize`Address 2`,
  CITY: $localize`City`,
  STATE_PROVINCE: $localize`State / Province`,
  POSTAL_CODE: $localize`Postal Code`,
  COUNTRY: $localize`Country`,
  CURRENCY: $localize`Currency`,
  LATITUDE: $localize`Latitude`,
  LONGITUDE: $localize`Longitude`,
  LAT_LONG_REQUIRED_INFO: $localize`Latitude and Longitude required for`,
  IDO_ENABLED_LOCATION: $localize`IDO Enabled Locations`,
  CONTACT_NAME: $localize`Contact Name`,
  SECONDARY_CONTACT_NAME: $localize`Secondary Contact Name`,
  CONTACT_EMAIL: $localize`Contact Email`,
  SECONDARY_CONTACT_EMAIL: $localize`Secondary Contact Email`,
  CONTACT_PHONE: $localize`Contact Phone`,
  SECONDARY_CONTACT_PHONE: $localize`Secondary Contact Phone`,
};

export const POPUP_LABEL = {
  HEADER: $localize`New Location Profile`,
  EDIT_HEADER: $localize`Edit Location Profile`,
  LOCATION: $localize`Location`,
  ADDRESS: $localize`Address`,
  GROUPS: $localize`Group`,
  CONFIGURATIONS: $localize`Configuration`,
};

export const GROUP_LABEL = {
  ASSIGNED_GROUPS: $localize`Assigned Groups`,
  UNASSIGN: $localize`Unassign`,
  ALL_GROUPS: $localize`All Groups`,
  ASSIGN: $localize`Assign`,
};
export const FOOTER_LABEL = {
  CANCEL: $localize`Cancel`,
  RESET: $localize`Reset`,
  NEXT: $localize`Next`,
  SAVE: $localize`Save`,
  CANCEL_MODAL: {
    HEADER: $localize`Cancel`,
    BODY: $localize`Are you sure you want to cancel? Your changes will not be saved.`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
  },
};
export const CONFIGURATION_LABEL = {
  CENTER_SLIC: $localize`Center Slic`,
  DATA_RETENTION: $localize`Data Retention `,
  LOCATION_TYPE: $localize`Location Type`,
  ENABLEMENTS: $localize`Enablements`,
  MESSAGING: $localize`Messaging`,
  GIO: $localize`GIO`,
  INTERCEPTS: $localize`Intercepts`,
  BYOD: $localize`BYOD`,
  DRIVER_RELEASE: $localize`Driver Release`,
  SAFE_PLACE_PHOTO: $localize`Safe Place Photo`,
  ADL: $localize`ADL`,
  HAZMAT: $localize`Hazmat`,
  ON_DEMAND_PICKUPS: $localize`On Demand Pickups`,
  ODPU_PROVIDE_RECEIPT: $localize`ODPU Provide Receipt`,
  FILE_UPLOAD: $localize`File Upload`,
  VISIBILITY: $localize`Visibility`,
  DRIVER_LOAD: $localize`Driver Load`,
  HANDOVER: $localize`Handover`,
  EDW_ETA: $localize`EDW/ETA API Only `,
  GTSTIMECARD: $localize`GTS Timecard +`,
  LOCATION: $localize`Location`,
  DRIVER: $localize`Driver`,
  SUP_GROUP: $localize`Sup Group`,
  SEND_TIME: $localize`Send Time (local)`,
  CONTRACTOR_ID: $localize`Contractor ID`,
  CONTRACTOR_NAME: $localize`Contractor Name`,
  INTERNATIONAL_DISPATCH_OPTIMIZATION: $localize`International Dispatch Optimization (IDO) + `,
  IDO: $localize`IDO`,
  IDO_TYPE: $localize`IDO Type`,
  LOCATION_START: $localize`Location Start`,
  BREAK_START: $localize`Break Start (hr)`,
  DEL_WAIT_TIME: $localize`DEL Wait Time (min)`,
  OPTIMIZE: $localize`Optimize`,
  LOCATION_END: $localize`Location End`,
  BREAK_END: $localize`Break End (hr)`,
  PU_WAIT_TIME: $localize`PU Wait Time (min)`,
  VEHICLE: $localize`Vehicle`,
  LEAVE_BLDG_TIME: $localize`Leave Bldg Time`,
  BREAK_DURATION: $localize`Break Duration (min)`,
  DISTANCE_UNITS: $localize`Distance Units`,
  EDW: $localize`EDW`,
  FMD: $localize`FMD`,
  ITINERARY_REORDERING: $localize`Itinerary Reordering`,
  FORECAST_SMART_SCAN: $localize`Forecast Smart Scan`,
  ADDITIONAL_TIMECARD_FEED: $localize`Additional Timecard Feed`,
  ENTER_ID: $localize`Enter ID`,
  ENTER_NAME: $localize`Enter Name`,
  ENTER_SUB_GROUP: $localize`Enter Sub Group`,
  SEND_TIME_PLACEHOLDER: $localize`Send Time`,
  SELECT: $localize`Select`,
  RETENTION_PLACEHOLDER: $localize`Enter Data Retention`,
  LOCATION_TYPE_PLACEHOLDER: $localize`Enter Location Type`,
  TRIMBLE_DISPATCH: $localize`Trimble Dispatch Planning`,
};

export const ERROR_MESSAGES = {
  LAT_LONG_REQUIRED: $localize`%s required for IDO Enabled Locations`,
};
export const IDO_TYPES = [
  {
    label: `Forecast/ S2C`,
    value: `Forecast/ S2C`,
  },
  {
    label: `S2C`,
    value: `S2C`,
  },
];
export const LOCATION_START = [
  {
    label: `Facility`,
    value: `Facility`,
  },
  {
    label: `Other`,
    value: `Other`,
  },
];
export const BREAK_HOUR = [
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: '6',
    value: '6',
  },
  {
    label: '7',
    value: '7',
  },
];
export const WAIT_TIME = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: '6',
    value: '6',
  },
  {
    label: '7',
    value: '7',
  },
  {
    label: '8',
    value: '8',
  },
  {
    label: '9',
    value: '9',
  },
  {
    label: '10',
    value: '10',
  },
];
export const OPTIMIZE = [
  {
    label: `Yes`,
    value: true,
  },
  {
    label: `No`,
    value: false,
  },
];
export const VEHICLE_LIST = [
  {
    label: `Minivan`,
    value: `Minivan`,
  },
  {
    label: `Cargo Van`,
    value: `Cargo Van`,
  },
  {
    label: `Cargo Van Large`,
    value: `Cargo Van Large`,
  },
  {
    label: `Truck Small`,
    value: `Truck Small`,
  },
  {
    label: `UPS Vehicle`,
    value: `UPS Vehicle`,
  },
];
export const DISTANCE_UNIT_LIST = [
  {
    label: `Kilometers`,
    value: `Kilometers`,
  },
  {
    label: `Miles`,
    value: `Miles`,
  },
];
export const ASSIGNED_GROUP_DATA: LocationGroup[] = [
  {
    id: 622912,
    version: 3,
    code: 'R16D79',
    name: 'Region 16, District 79',
    numberOfSites: 7,
  },
  {
    id: 47259373,
    version: 1,
    code: 'CUSTSOLU',
    name: 'CUSTOMER SOLUTIONS',
    numberOfSites: 5,
  },
  {
    id: 3191872,
    version: 7,
    code: 'FREIGHT',
    name: 'Freight',
    numberOfSites: 2,
  },
];
export const ALL_GROUP_DATA: LocationGroup[] = [
  {
    id: 622912,
    version: 3,
    code: 'R16D79',
    name: 'Region 16, District 79',
    numberOfSites: 7,
  },
  {
    id: 47259373,
    version: 1,
    code: 'CUSTSOLU',
    name: 'CUSTOMER SOLUTIONS',
    numberOfSites: 5,
  },
  {
    id: 3191872,
    version: 7,
    code: 'FREIGHT',
    name: 'Freight',
    numberOfSites: 2,
  },
  {
    id: 2024,
    version: 0,
    code: 'R17D12',
    name: 'Region 17, District 12',
    numberOfSites: 12,
  },
  {
    id: 97673186,
    version: 0,
    code: 'R16D6',
    name: 'Region 16 District 6',
    numberOfSites: 4,
  },
  {
    id: 6757496,
    version: 0,
    code: 'EXTERNAL',
    name: 'External clients',
    numberOfSites: 3,
  },
  {
    id: 621444,
    version: 6,
    code: 'LUCIA',
    name: 'TEST',
    numberOfSites: 24,
  },
  {
    id: 3,
    version: 1052,
    code: 'TEST',
    name: 'TEST',
    numberOfSites: 163,
  },
];

export type SwitchTabData = {
  data: { profile: LocationProfile; edit: boolean };
  tab: string;
  redirect?: boolean;
};
